import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import i18n from "../../i18n";
const createAxiosInstance = () => {
  const token = sessionStorage.getItem("usr_1a2b3c");
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Fetch the pharmacy financial dashboard metrics (Total Earnings, COD, Online Payments,
// Admin Fees, Commission, Net Balance, Withdrawals, Transportation Fees) for the selected order
// type (normal / insured). Mirrors the doctor dashboard-metrics flow.
export const fetchPharmacyFinancialMetrics = createAsyncThunk(
  "pharmacyFinancialMetrics/fetch",
  async (arg, { rejectWithValue }) => {
    try {
      const orderType = arg?.order_type === "insured" ? "insured" : "normal";
      const axiosInstance = createAxiosInstance();
      const params = new URLSearchParams({ order_type: orderType });
      if (arg?.date_from) params.append("date_from", arg.date_from);
      if (arg?.date_to) params.append("date_to", arg.date_to);
      const response = await axiosInstance.get(
        `/api/v1/pharmacy/wallet/dashboard-metrics?${params.toString()}`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching pharmacy financial metrics:", error);
      return rejectWithValue(
        error.response?.data?.message || i18n.t("toast.failedToFetchDashboardMetrics"),
      );
    }
  },
);

const pharmacyFinancialMetricsSlice = createSlice({
  name: "pharmacyFinancialMetrics",
  initialState: {
    data: null,
    loading: false,
    error: null,
    // requestId of the most recent fetch. Only that request may write the result, so a slow
    // earlier response (e.g. "From only" while the user is still picking "To", or the other
    // insurance bucket) can never overwrite the figures for the filter currently selected.
    latestRequestId: null,
  },
  reducers: {
    clearPharmacyFinancialMetrics: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.latestRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPharmacyFinancialMetrics.pending, (state, action) => {
        state.latestRequestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPharmacyFinancialMetrics.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchPharmacyFinancialMetrics.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
        // Don't leave the previous filter's figures on screen as if they matched this one.
        state.data = null;
      });
  },
});

export const { clearPharmacyFinancialMetrics } =
  pharmacyFinancialMetricsSlice.actions;
export default pharmacyFinancialMetricsSlice.reducer;
